import { Controller } from "@hotwired/stimulus"

// Labels the Get Started submit for what saving does to the current scan, and
// asks before a changed address replaces its results. Website::UpdateStart
// decides the same way on the server, so this is only presentation.
export default class extends Controller {
  static targets = ["address", "submit"]
  static values = { address: String, hasResults: Boolean }

  connect() {
    this.update()
  }

  update() {
    const address = this.normalize(this.addressTarget.value)
    const changed = address !== this.normalize(this.addressValue)
    const replacing = changed && this.hasResultsValue

    let label = "Next"
    if (changed) {
      if (address) {
        label = replacing ? "Replace Results With New Scan" : "Save and Scan"
      } else {
        label = replacing ? "Remove Scan Results" : "Save and Continue"
      }
    }
    this.submitTarget.querySelector("span").textContent = label

    const data = this.element.dataset
    if (replacing) {
      data.turboConfirm = address
        ? `Replace your scan results with a scan of ${address}?`
        : "Remove your scan results?"
      data.body =
        "Your page list is reset to the template (custom pages are removed), and the images, links, and business summary from your current site are deleted. Images you uploaded, links you added, and your brief answers are kept."
      data.button = label
      data.style = "destructive"
    } else {
      for (const key of ["turboConfirm", "body", "button", "style"]) delete data[key]
    }
  }

  // Mirrors the server: "example.com" means https://example.com.
  normalize(value) {
    const address = value.trim()
    if (!address) return ""
    return /^[a-z][a-z0-9+.-]*:\/\//i.test(address) ? address : `https://${address}`
  }
}
